import { createFileRoute } from '@tanstack/react-router';
import { UserPlus } from 'lucide-react';
import { LeadsTable } from '@/components/users/LeadsTable';

export const Route = createFileRoute('/_admin/leads')({
  component: LeadsPage,
});

function LeadsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <UserPlus className="h-7 w-7" />
            Acompanhamento de Leads
          </h1>
          <p className="text-muted-foreground">Monitoramento em tempo real dos cadastros em andamento</p>
        </div>
      </div>

      <LeadsTable />
    </div>
  );
}
